module.exports = __webpack_public_path__ + "static/img/system_log_blue.d60f2f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system_log_blue.svg
// module id = KJmh
// module chunks = 1